// Deutsche FAQ für Kontaktseite
export const DEFAULT_FAQS_DE = [
  {
    question: "Wie komme ich am einfachsten zu euch nach Råstrand, Lappland?",
    answer: [
      "Die Entfernung von Malmö zu unserem Haus beträgt etwa 1500 km.",
      "Am schnellsten und bequemsten geht es mit dem Flugzeug. Ein Ticket nach Lappland kostet kaum mehr als zwei volle Tankfüllungen und wird sehr empfohlen.",
      "Wir holen und bringen unsere Gäste immer zu den Flughäfen Skellefteå, Luleå oder Lycksele."
    ]
  },
  {
    question: "Wie fliege ich am besten zu euch?",
    answer: [
      "Je nach Wohnort fliegen Sie nach Arlanda in Stockholm.",
      "Von dort nehmen Sie einen Inlandsflug mit Amapola nach Lycksele (100 km von uns entfernt). Der Transfer ist im Winterpaket enthalten und die Tickets werden auf amapola.nu gebucht.",
      "Sie können auch nach Skellefteå oder Luleå fliegen und mit einem Mietwagen weiterfahren. Diese Flughäfen sind weiter entfernt, aber die Tickets sind manchmal sehr günstig. Wir helfen Ihnen gerne, die besten Optionen zu finden."
    ]
  },
  {
    question: "Kann ich mit meinem eigenen Auto zu euch fahren?",
    answer: [
      "Ja, aber achten Sie auf gute Winterreifen. Seien Sie vorsichtig, da es viele Wildtiere auf den Straßen gibt.",
      "Von Stockholm nach Råstrand dauert es etwa 9–10 Stunden mit dem Auto.",
      "Sie finden Råstrand am einfachsten, indem Sie nach 'Cold Experience Lapland' auf Google Maps suchen."
    ]
  },
  {
    question: "Sind Schneemobilkleidung, Stiefel und Helme inklusive?",
    answer: [
      "Ja, wir stellen die Oberbekleidung zur Verfügung. Die Schneemobilkleidung ist warm – Sie tragen Thermounterwäsche und bequeme Kleidung darunter."
    ]
  },
  {
    question: "Welche Kleidung soll ich mitbringen?",
    answer: [
      "Wir empfehlen Ihnen, folgendes zu packen:",
      "1. Hochwertige Thermounterwäsche",
      "2. Normale Socken",
      "3. Pullover oder Fleecejacke",
      "4. Warme Fleecehose / bequeme Hose",
      "5. Warme Wollsocken",
      "6. Winterjacke oder Skianzug",
      "7. Winterschuhe / Stiefel",
      "8. Mütze und Balaklava zum Tragen unter dem Helm",
      "9. Schal",
      "10. Gute Handschuhe",
      "11. Sonnenbrille oder Skibrille",
      "12. Badebekleidung",
      "Punkt 6 und 7 werden draußen getragen, wenn Sie kein Schneemobil fahren. Bei Schneemobiltouren erhalten Sie Overall, Schuhe und Helm.",
      "In Schweden zieht man die Schuhe im Haus aus, bringen Sie also gerne warme Hausschuhe oder dicke Socken für den Innenbereich mit."
    ]
  },
  {
    question: "Gibt es etwas, das ich nicht mitbringen muss?",
    answer: [
      "Wir stellen Bettwäsche, Handtücher, Bademäntel und Hausschuhe zur Verfügung.",
      "Ein Haartrockner ist im Badezimmer vorhanden.",
      "Kaffee, Tee, Wasser und Saft sind im Vollpensionspaket enthalten."
    ]
  },
  {
    question: "Was ist nicht in der Vollpension enthalten?",
    answer: [
      "Alkoholische Getränke sind nicht enthalten. Bringen Sie Bargeld mit, wenn Sie welche kaufen möchten."
    ]
  },
  {
    question: "Brauche ich eine zusätzliche Versicherung?",
    answer: [
      "Ja, kaufen Sie eine Reiseversicherung, die Abenteueraktivitäten abdeckt.",
      "Überprüfen Sie auch, ob Ihre Krankenversicherung im Ausland gültig ist und bringen Sie einen Nachweis mit."
    ]
  },
  {
    question: "Brauche ich einen speziellen Führerschein für Schneemobile?",
    answer: [
      "Nein, ein normaler Führerschein reicht aus.",
      "Alle Fahrer müssen ihren Führerschein dabei haben. Da Sie immer mit unserem Guide fahren, reicht es aus, dass der Guide alle notwendigen Genehmigungen hat.",
      "Überprüfen Sie auch, ob Ihr Reisepass oder Ausweis gültig ist."
    ]
  },
  {
    question: "Kann ich ausländische Währung in Schweden verwenden?",
    answer: [
      "Nein, Sie müssen in schwedische Kronen (SEK) wechseln, um bei uns oder im Dorfladen einzukaufen.",
      "Die meisten anderen Geschäfte akzeptieren VISA und Mastercard."
    ]
  }
];
